import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	FormHelperText
} from "@mui/material";

interface CancelDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: (motivoCancelamento: number, justificativa: string) => void;
	nfseCode?: string;
	loading?: boolean;
}

const MOTIVOS_CANCELAMENTO = [
	{ value: 1, label: "Erro na emissão" },
	{ value: 2, label: "Serviço não prestado" },
	{ value: 9, label: "Outros" }
];

const CancelDialog: React.FC<CancelDialogProps> = ({
	open,
	onClose,
	onConfirm,
	nfseCode,
	loading = false
}) => {
	const [motivoCancelamento, setMotivoCancelamento] = useState<number>(1);
	const [justificativa, setJustificativa] = useState<string>("");
	const [errors, setErrors] = useState<{ motivo?: string; justificativa?: string }>({});

	const handleConfirm = () => {
		const newErrors: { motivo?: string; justificativa?: string } = {};

		if (!motivoCancelamento) {
			newErrors.motivo = "Motivo de cancelamento é obrigatório";
		}

		if (!justificativa.trim()) {
			newErrors.justificativa = "Justificativa é obrigatória";
		}

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return;
		}

		onConfirm(motivoCancelamento, justificativa.trim());
	};

	const handleClose = () => {
		if (!loading) {
			setMotivoCancelamento(1);
			setJustificativa("");
			setErrors({});
			onClose();
		}
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth="sm"
			fullWidth
			disableEscapeKeyDown={loading}
		>
			<DialogTitle>
				Cancelar NFSe {nfseCode && `- ${nfseCode}`}
			</DialogTitle>
			<DialogContent>
				<div style={{ paddingTop: 16 }}>
					<FormControl fullWidth error={!!errors.motivo} style={{ marginBottom: 16 }}>
						<InputLabel>Motivo do Cancelamento</InputLabel>
						<Select
							value={motivoCancelamento}
							onChange={(e) => {
								setMotivoCancelamento(Number(e.target.value));
								if (errors.motivo) {
									setErrors({ ...errors, motivo: undefined });
								}
							}}
							label="Motivo do Cancelamento"
							disabled={loading}
						>
							{MOTIVOS_CANCELAMENTO.map((motivo) => (
								<MenuItem key={motivo.value} value={motivo.value}>
									{motivo.value} - {motivo.label}
								</MenuItem>
							))}
						</Select>
						{errors.motivo && <FormHelperText>{errors.motivo}</FormHelperText>}
					</FormControl>

					<TextField
						fullWidth
						multiline
						rows={4}
						label="Justificativa"
						value={justificativa}
						onChange={(e) => {
							setJustificativa(e.target.value);
							if (errors.justificativa) {
								setErrors({ ...errors, justificativa: undefined });
							}
						}}
						error={!!errors.justificativa}
						helperText={errors.justificativa || "Descreva o motivo detalhado do cancelamento"}
						disabled={loading}
						placeholder="Ex: Nota emitida com dados incorretos do cliente..."
					/>
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} disabled={loading}>
					Cancelar
				</Button>
				<Button
					onClick={handleConfirm}
					color="error"
					variant="contained"
					disabled={loading}
				>
					{loading ? "Cancelando..." : "Confirmar Cancelamento"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CancelDialog;


